import endpoints from '@/constants/endpoints';
import axiosV2 from '../axiosv2';
import {
  CurrentBalanceResponse,
  ExecuteDisbursementRequest,
} from '../model/disbursement/disbursementDto';

export const getCurrentBalance = async (): Promise<CurrentBalanceResponse> => {
  const endpoint = endpoints.disbursement.getCurrentBalance;
  const response = await axiosV2.get<CurrentBalanceResponse>(endpoint);
  return response;
};

export const executeDisbusement = async (
  request: ExecuteDisbursementRequest
): Promise<void> => {
  const endpoint = endpoints.disbursement.executeDisbursement;
  await axiosV2.post(endpoint, request);
  return;
};
